import { appendUrlParams } from '@/utils/generator'
import axios from './axios'

export const fetchQuestions = async (payload = {}) => {
  const paramsPayload = {
    page: payload.page || 1,
    perPage: payload.perPage || 25,
    searchText: payload.search || '',
    categories: payload?.categories?.toString() || '',
    sortBy: payload.sortBy || '',
    sortDesc: payload.sortDesc || false,
    user: payload.user || '',
  }
  if (payload.scope) paramsPayload.scope = payload.scope
  const params = appendUrlParams(paramsPayload)
  const {
    data: { questions, count },
  } = await axios.get(`/question?${params.toString()}`)
  return { questions, count }
}

export const fetchQuestionById = async id => {
  const { data } = await axios.get('/question/' + id)
  return data
}

export const storeQuestion = async payload => {
  const { data } = await axios.post('/question', payload)
  return data
}

export const storeManyQuestions = async payload => {
  const { data } = await axios.post('/question/many', payload.questions)
  return data
}

export const destroyQuestion = async id => {
  await axios.delete('/question/' + id)
}

export const updateQuestion = async payload => {
  const { data } = await axios.put('/question/' + payload._id, payload)
  return data
}

export const replicateQuestion = async id => {
  const { data } = await axios.post('/question/replicate/' + id)
  return data
}

export const importQuestions = async questions => {
  const { data } = await axios.post('/question/many', questions)
  return data
}

export const generateAIQuestions = async payload => {
  const { data } = await axios.post('/question/ai-generate', payload)
  return data
}

export const editAIQuestion = async payload => {
  const { data } = await axios.post('/question/ai-edit', payload)
  return data
}
